import * as Sentry from '@sentry/vue'
import { Http } from 'vue-resource'
import { gerarUrlDoKeycloak } from '../../api'
import store from '../../store/store'

export const obterParametrosAutenticacaoKeycloak = () => {
  const urlParams = new URLSearchParams(window.location.search)

  const sessionState = urlParams.get('session_state')
  const code = urlParams.get('code')
  const realm = urlParams.get('realm')

  return {
    sessionState,
    code,
    realm
  }
}

export const possuiParametrosAutenticacaoKeycloak = () => {
  const parametros = obterParametrosAutenticacaoKeycloak()

  return Object.values(parametros).every(Boolean)
}

export function construirUrlDeRedirecionamentoKeycloak (realm) {
  return `${window.location.origin}${window.location.pathname}?realm=${realm}`
}

async function obterTokenDoKeycloakAPartirDaSessao (realm, codigo, sessao, redirectUri) {
  const result = await Http.post(`${gerarUrlDoKeycloak()}/realms/${realm}/protocol/openid-connect/token`, {
    grant_type: 'authorization_code',
    client_id: 'pontotel',
    session_state: sessao,
    code: codigo,
    redirect_uri: redirectUri
  }, {
    emulateJSON: true
  })
  return result
}

export const keycloakSSOLogin = async () => {
  try {
    const { realm, code, sessionState } = obterParametrosAutenticacaoKeycloak()

    if (!possuiParametrosAutenticacaoKeycloak()) {
      throw new Error('Parâmetros do Keycloak não encontrados na URL.')
    }

    const urlDeRedirecionamento = construirUrlDeRedirecionamentoKeycloak(realm)

    const resposta = await obterTokenDoKeycloakAPartirDaSessao(realm, code, sessionState, urlDeRedirecionamento)

    const { access_token: accessToken, refresh_token: refreshToken } = resposta.data

    store.commit('regularToken', accessToken, {root: true})
    store.commit('email', '')
    store.commit('password', '')
    store.dispatch('coletor/buscarColetores', {}, {root: true})

    return {accessToken, refreshToken}
  } catch (erro) {
    Sentry.captureException(erro)
  }
}
